import React from 'react';
import { Route } from 'react-router';

import MobileTopicList from '../components/MobileTopicList';
import MobileArticleList from '../components/MobileArticleList';
import Article from '../containers/ArticlePanel';

import SearchFilterForm from '../containers/SearchFilterForm';
import SearchResult from '../containers/SearchResult';

const routes = [
  { path: '/:experience/home',
    exact: true,
    sideBar: null,
    mainContainer: () => <MobileTopicList />,
  },
  { path: '/:experience/topic/:topicId',
    sideBar: null,
    mainContainer: () => <MobileArticleList />,
  },
  { path: '/:experience/article/:articleId',
    sideBar: null,
    mainContainer: () => <Article />,
  },
  { path: '/:experience/search',
    exact: true,
    sideBar: () => <SearchFilterForm />,
    mainContainer: () => <SearchResult />,
  },
];

const SideBar = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.sideBar}
      />
       ))
     }
  </div>;

const MainContainer = () =>
  <div>
    { routes.map(route => (
      <Route
        key={route.path}
        path={route.path}
        exact={route.exact}
        component={route.mainContainer}
      />
       ))
     }
  </div>;

export default {
  sideBar: <SideBar />,
  mainContainer: <MainContainer />,
};



// WEBPACK FOOTER //
// ./home/routes/MobileRoutes.js